module.exports = "<% _.each(menu, function(itm, menuId){ %> <div class=tip-btn menuid=\"<%= menuId %>\"> <i class=\"<%= 'icon-' + itm.icon %>\"></i> <span><%= itm.name %></span> </div> <% }) %> ";


//////////////////
// WEBPACK FOOTER
// ./src/js/app/pages/main/tenantInfo/template/indexTpl.html
// module id = 246
// module chunks = 0